export default __webpack_public_path__ + "static/test_1_5_ru-c543f09015bc87ecee838e8e6b6266af.png";